import { Exercise as ComponentExercise } from "@/services/admin/exercises.interfaces";
import { LucideIcon } from "lucide-react";
import { BookOpen } from "lucide-react";
import { EditorInterface } from "./EditorInterface";
import { CardInfo } from "./types";

/**
 * Classe de informações para exercícios do tipo Texto Formatado
 */
export class FormattedTextEditor extends EditorInterface {
  /**
   * Retorna as informações para exibir no cartão do exercício
   * @param exercise Objeto do exercício
   */
  static GetCardInfo(exercise: ComponentExercise): CardInfo {
    console.log("FormattedTextEditor.GetCardInfo - Exercício recebido:", exercise);
    
    try {
      let data: { title?: string; content?: string } = {};
      
      // Se exercise.data é uma string, fazer o parsing
      if (typeof exercise.data === 'string') {
        console.log("FormattedTextEditor.GetCardInfo - Fazendo parsing da string JSON:", exercise.data);
        data = JSON.parse(exercise.data);
      } 
      // Se já é um objeto, usar diretamente
      else if (exercise.data && typeof exercise.data === 'object') {
        console.log("FormattedTextEditor.GetCardInfo - Dados já são objeto:", exercise.data);
        data = exercise.data as { title?: string; content?: string };
      }
      
      console.log("FormattedTextEditor.GetCardInfo - Dados processados:", data);
      
      // Use title from data if available, otherwise use exercise.title or fallback
      const title = data.title || (exercise as any).title || 'Texto Formatado';
      const content = data.content || '';
      
      const result = {
        title: title,
        subtitle: content.length > 60 ? `${content.substring(0, 60)}...` : content || 'Conteúdo de texto formatado',
        description: content ? `${content.slice(0, 100)}${content.length > 100 ? '...' : ''}` : 'Sem conteúdo'
      };
      
      console.log("FormattedTextEditor.GetCardInfo - Resultado:", result);
      return result;
    } catch (error) {
      console.error("FormattedTextEditor.GetCardInfo - Erro ao processar dados:", error);
      return {
        title: 'Texto Formatado',
        subtitle: 'Erro ao processar dados',
        description: 'Erro ao ler conteúdo'
      };
    }
  }
  
  /**
   * Retorna o título do tipo de exercício
   */
  static getTitle(): string {
    return 'Texto Formatado';
  }
  
  /**
   * Retorna uma descrição do exercício formatada para exibição
   * @param exercise Objeto do exercício
   */
  static getDescription(exercise: ComponentExercise): string {
    try {
      let data: { title?: string; content?: string } = {};
      
      // Se exercise.data é uma string, fazer o parsing
      if (typeof exercise.data === 'string') {
        data = JSON.parse(exercise.data);
      } 
      // Se já é um objeto, usar diretamente
      else if (exercise.data && typeof exercise.data === 'object') {
        data = exercise.data as { title?: string; content?: string };
      }
      
      return data.title || (exercise as any).title || 'Texto formatado';
    } catch (error) {
      console.error("FormattedTextEditor.getDescription - Erro ao processar dados:", error);
      return 'Texto formatado';
    }
  }
  
  /**
   * Retorna o ícone correspondente ao tipo do exercício
   */
  static getIcon(): LucideIcon {
    return BookOpen;
  }
  
  /**
   * Verifica se o exercício é do tipo Texto Formatado
   */
  static SupportsExerciseType(type: string): boolean {
    return type === 'formatted_text';
  }
} 